import React from 'react'
import type { CommonDeps } from '../base/CommonDeps'
import ErrorBoundary from '../error/ErrorBoundary'
import { Toaster } from '../ui/Toaster'
import { DocumentLanguage } from './DocumentLanguage'

type TProps = {
    deps: CommonDeps
    header: React.ReactElement<unknown>
    footer?: React.ReactElement<unknown>
    hideHeader?: boolean
    hideFooter?: boolean
    leftContent?: React.ReactElement<unknown>
}

export class Page extends React.Component<TProps, {}> {
    public render() {
        const { header, hideHeader, footer, hideFooter, leftContent, children } = this.props

        return (
            <div className="AppCore__page__Page">
                <DocumentLanguage lang={this.props.deps?.language} />

                {!hideHeader && (
                    <div className="AppCore__page__Page__header">
                        <ErrorBoundary deps={this.props.deps}>{header}</ErrorBoundary>
                    </div>
                )}
                <div className="AppCore__page__Page__content">
                    <ErrorBoundary deps={this.props.deps}>{leftContent}</ErrorBoundary>
                    <div className="AppCore__page__Page__body">
                        <ErrorBoundary deps={this.props.deps}>{children}</ErrorBoundary>
                    </div>

                    <Toaster limit={3} />
                </div>
                {!hideFooter && (
                    <div className="AppCore__page__Page__footer">
                        <ErrorBoundary deps={this.props.deps}>{footer}</ErrorBoundary>
                    </div>
                )}
            </div>
        )
    }
}
